import { ref } from "vue";
import type { ConfirmData } from "..";

const opened = ref(false);
const confirmDialogData = ref<ConfirmData>();

export const useConfirmDialog = () => {
  const { $emitter } = useNuxtApp();

  const confirm = (data: ConfirmData): Promise<boolean | string> => {
    if (data.type === undefined) {
      data.type = "danger";
    }

    confirmDialogData.value = data;
    opened.value = true;

    return new Promise((resolve, reject) => {
      if ($emitter === undefined) {
        reject("Emitter is not defined!");
        return;
      }

      // @ts-expect-error
      $emitter.on("dialog-confirmed", (inputData: string) => {
        opened.value = false;

        if (inputData !== "" && inputData !== undefined) {
          resolve(inputData);
        }

        resolve(true);
      });

      $emitter.on("dialog-canceled", () => {
        opened.value = false;
        resolve(false);
      });
    });
  };

  return {
    opened,
    confirmDialogData,
    confirm,
  };
};
